import { render, staticRenderFns } from "./BonusDetail.vue?vue&type=template&id=4ee97693"
import script from "./BonusDetail.vue?vue&type=script&lang=js"
export * from "./BonusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports